<template>
  <button
      class="back-btn p-0"
      :style="{position: position}"
      @click="goBack"
      title="Go back"
      aria-label="Go back"
  >
    <i class="fas fa-arrow-left"></i>
  </button>
</template>

<script>
export default {
  props: {
    position: {
      type: String,
      default: 'absolute',
    },
    to: {
      type: String,
    }
  },
  name: 'BackBtn',
  methods: {
    goBack() {
      if (this.to) {
        this.$router.push(this.to)
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-top-btn-wrap {
  position: fixed;
  left: 6px;
  top: 6px;
  z-index: 10;
}

.back-btn {
  //position: absolute;
  left: 0;
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  border-radius: 50%;
  border: 1px solid rgba(214, 182, 116, 0.45);
  background: white;
  z-index: 10;
  color: #d6b674;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.18s, color 0.18s, transform 0.15s;

  &:hover {
    background: linear-gradient(135deg, #d6b674 0%, #c4a55a 100%);
    color: #fff;
    transform: scale(1.06);
  }
}


</style>
